module.exports = __webpack_public_path__ + "img/49.cb27821c.svg";